module.exports = __webpack_public_path__ + "images/for_company_page/voice-kaitori_21ec757e0b3d9aec8e4c4a1ae532c89c.jpg";